module.exports = require("./ru-BY.js");